import { getRoutes } from 'app/pages/Securities/routes'

const routes = getRoutes()

export { routes }
